<template>
  <div id="page">
    <b-container>
      <div infinite-scroll-disabled="busy" infinite-scroll-distance="10">
        <div>
          <b-card class="mb-2">
            <b-container class="text-left">
              <b-row style="margin-top: 4px;">
                <b-col>Bank card number</b-col>
              </b-row>
              <b-row>
                <b-col
                  ><b>{{ sizeFrom.cardNumber }}</b></b-col
                >
              </b-row>
            </b-container>
            <b-container class="text-left">
              <b-row style="margin-top: 4px;">
                <b-col>Name</b-col>
              </b-row>
              <b-row>
                <b-col
                  ><b>{{ sizeFrom.customName }}</b></b-col
                >
              </b-row>
            </b-container>
            <b-container class="text-left">
              <b-row style="margin-top: 4px;">
                <b-col>Phone number</b-col>
              </b-row>
              <b-row>
                <b-col
                  ><b>{{ sizeFrom.customPhone }}</b></b-col
                >
              </b-row>
            </b-container>
            <b-container class="text-left">
              <b-row style="margin-top: 4px;">
                <b-col>Card face</b-col>
              </b-row>
              <b-row>
                <b-col cols="12">
                  <img :src="sizeFrom.imageUrl" style="width: 256px" />
                </b-col>
              </b-row>
            </b-container>
            <hr />
            <div style="text-align: center;">
              <b-button variant="danger" @click="confirm()">Ok</b-button>
            </div>
          </b-card>
        </div>
      </div>
    </b-container>
  </div>
</template>

<script>
export default {
  name: "OrderList_Dubai",
  data() {
    return {
      sizeFrom: {}
    };
  },
  watch: {},
  methods: {
    confirm() {
      sessionStorage.clear();
      this.$router.push({ name: "Home_Dubai" });
    }
  },
  mounted: function() {
    let obj = this.$route.params.bankSerialObj;
    this.sizeFrom = JSON.parse(obj);
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/DubaiCard/OrderList_Dubai.vue